/**
 * Coerce API quote extraction values into review-friendly nulls.
 */

/**
 * @param {*} value
 * @returns {string|null}
 */
export function emptyToNull(value) {
  if (value == null) return null;
  const s = String(value).trim();
  return s === '' ? null : s;
}

/**
 * @param {*} value
 * @returns {number|null}
 */
export function emptyToNullNumber(value) {
  if (value == null || value === '') return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

/**
 * First non-empty string from candidates (after trim).
 *
 * @param {...*} candidates
 * @returns {string|null}
 */
export function pickNonEmptyString(...candidates) {
  for (const c of candidates) {
    const v = emptyToNull(c);
    if (v != null) return v;
  }
  return null;
}

/**
 * First finite number from candidates.
 *
 * @param {...*} candidates
 * @returns {number|null}
 */
export function pickNumber(...candidates) {
  for (const c of candidates) {
    const n = emptyToNullNumber(c);
    if (n != null) return n;
  }
  return null;
}

/**
 * Rhenium PDFs sometimes return supplier name as "web site: https://...".
 *
 * @param {string|null} name
 * @param {string|null} website
 * @returns {{ name: string|null, website: string|null }}
 */
export function normalizeSupplierNameAndWebsite(name, website) {
  let n = emptyToNull(name);
  let w = emptyToNull(website);

  if (n && /web\s*site\s*:/i.test(n)) {
    const urlMatch = n.match(/https?:\/\/[^\s,)]+/i);
    if (urlMatch && !w) {
      w = urlMatch[0].replace(/[.,;]+$/, '');
    }
    n = null;
  }

  if (n && /^https?:\/\//i.test(n)) {
    if (!w) w = n;
    n = null;
  }

  return { name: n, website: w };
}
